
import { computed, defineComponent } from "vue";

import appleAppStoreImage from "../../assets/apple-app-store.svg";

export default defineComponent({
  props: {
    href: {
      type: String,
      default: "",
    },
    width: {
      type: [Number, String],
      default: 135,
    },
    height: {
      type: [Number, String],
      default: 40,
    },
  },
  emits: {
    "open-store": (_v: string) => true,
  },
  setup(props) {
    const link = computed(() => {
      // Explicit Providid Override
      if (props.href !== "") {
        return props.href;
      }

      return "https://ltk.app.link/fLHsPHg3MR";
    });

    return {
      link,
      imageSrc: appleAppStoreImage,
    };
  },
});
